import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftCardIDPipe } from './gift-card-id.pipe';

@NgModule({
    declarations: [GiftCardIDPipe],
    imports: [CommonModule],
    exports: [GiftCardIDPipe],
})
export class GiftCardIDModule {}
